'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Modal, _Component);

  function Modal() {
    (0, _classCallCheck3.default)(this, Modal);
    return (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).apply(this, arguments));
  }

  (0, _createClass3.default)(Modal, [{
    key: 'render',
    value: function render() {
      var instructions = this.props.strings.instructions;
      var modalClass = (0, _classnames2.default)({
        'modalInstructions': true,
        'show': this.props.isOpen ? true : false
      });

      return _react2.default.createElement(
        'ul',
        { className: modalClass + ' ' + 'num-' + instructions.length },
        (0, _keys2.default)(instructions).map(function (index) {
          return _react2.default.createElement(
            'li',
            { key: 'lay3r' + index },
            _react2.default.createElement('span', { className: "bg bg" + index }),
            _react2.default.createElement('i', { className: instructions[index].icon }),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: 'line' },
                ' '
              ),
              _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: instructions[index].txt } }),
              _react2.default.createElement(
                'span',
                { className: 'line' },
                ' '
              )
            )
          );
        }, this)
      );
    }
  }]);
  return Modal;
}(_react.Component), _class.propTypes = {
  isOpen: _react.PropTypes.bool.isRequired,
  strings: _react.PropTypes.object.isRequired
}, _temp);
exports.default = Modal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.js
// module id = 351
// module chunks = 0